export default __webpack_public_path__ + "static/media/cross.68f89323.svg";